import { JoynV2Api } from '../api/joyn/JoynApi';

class ZipcodeInsightsRepository {
  getInsights = (request) => JoynV2Api.post('/sammy/zipcode-insights', request);
}

const zipcodeInsightsRepository = new ZipcodeInsightsRepository();

export default zipcodeInsightsRepository;
